import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import {
  getPaymentTransactionStatusV3,
  createPaymentTransactionForInvoiceV3,
  createPaymentTransactionForPaymentArrangementV3,
  createPaymentTransactionForFreeDepositV3,
} from '../services/FinancialsV3Service';

export const useFinancialsV3GetPaymentTransactionStatusV3 = createDCHook(
  'getPaymentTransactionStatusV3',
  collapseDataFromCall(getPaymentTransactionStatusV3),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useFinancialsV3CreatePaymentTransactionForInvoiceV3 = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(createPaymentTransactionForInvoiceV3, 'requestBody', 'data'),
      'data',
      'paymentAmount',
      'merchantReturnUrl',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['paymentAmount', 'merchantReturnUrl'] },
    ],
  },
);

export const useFinancialsV3CreatePaymentTransactionForPaymentArrangementV3 = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(createPaymentTransactionForPaymentArrangementV3, 'requestBody', 'data'),
      'data',
      'paymentAmount',
      'merchantReturnUrl',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['paymentAmount', 'merchantReturnUrl'] },
    ],
  },
);

export const useFinancialsV3CreatePaymentTransactionForFreeDepositV3 = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(createPaymentTransactionForFreeDepositV3, 'requestBody', 'data'),
      'data',
      'paymentAmount',
      'merchantReturnUrl',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['paymentAmount', 'merchantReturnUrl'] },
    ],
  },
);
